var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconamoonArrowUp2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3333 14.9999C28.6629 15 28.9851 15.0978 29.2591 15.2809C29.5331 15.4641 29.7467 15.7244 29.8728 16.0289C29.9989 16.3334 30.0319 16.6684 29.9677 16.9917C29.9034 17.3149 29.7447 17.6119 29.5117 17.8449L21.1783 26.1783C20.8658 26.4907 20.442 26.6663 20 26.6663C19.5581 26.6663 19.1342 26.4907 18.8217 26.1783L10.4883 17.8449C10.2553 17.6119 10.0967 17.3149 10.0324 16.9917C9.96809 16.6684 10.0011 16.3334 10.1272 16.0289C10.2533 15.7244 10.4669 15.4641 10.7409 15.2809C11.0149 15.0978 11.3371 15 11.6667 14.9999H28.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonArrowUp2Fill);
export default __webpack_public_path__ + "static/media/iconamoon_arrow-up-2-fill.4390eb5928818cfa55e9d99291a272f0.svg";
export { ForwardRef as ReactComponent };